import React, { useState } from 'react';
import { Integration, IntegrationWrapper } from './types';
import IntegrationItem from './IntegrationItem';

interface IntegrationsListProps {
  integrations: IntegrationWrapper[];
  onConfigure: (integration: IntegrationWrapper) => void;
  onStatusToggle: (id: number, currentStatus: boolean) => void;
  onCustomerIntegrationToggle?: (customerIntegrationId: number, currentStatus: boolean) => void;
}

const IntegrationsList: React.FC<IntegrationsListProps> = ({
  integrations,
  onConfigure,
  onStatusToggle,
  onCustomerIntegrationToggle
}) => {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredIntegrations = activeCategory === 'All' ? integrations : integrations.filter(i => i.integration.CategoryName === activeCategory);

  const categories = [
    { id: 'All', name: 'All' },
    { id: 'Development', name: 'Development' },
    { id: 'Support', name: 'Support' },
    // { id: 'Finance', name: 'Finance' },
    // { id: 'Talent', name: 'Talent' },
    // { id: 'Sales', name: 'Sales' }    
  ];

  return (
    <div>
      <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>Integrations</h2>
      <p>Connect execdash to your favorite tools and services.</p>

      <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
        {categories.map(category => (
          <button
            key={category.id}
            onClick={() => setActiveCategory(category.id)}
            style={{
              padding: '8px 16px',
              background: activeCategory === category.id ? 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(-77, 182, 159) 162%)' : '#f0f0f0',
              color: activeCategory === category.id ? 'white' : 'black',
              border: 'none',
              borderRadius: 20,
              cursor: 'pointer'
            }}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {filteredIntegrations.map(integration => (
          <IntegrationItem
            key={integration.integration.Id}
            integration={integration}
            onConfigure={onConfigure}
            onStatusToggle={onStatusToggle}
            onCustomerIntegrationToggle={onCustomerIntegrationToggle}
            showStatusToggle={!integration.integration.AllowMultiple && integration.integration.Enabled && integration.configured}
          />
        ))}
      </div>
    </div>
  );
};

export default IntegrationsList;
